document.addEventListener('DOMContentLoaded', () => {
  const topLevelDetails = document.querySelectorAll('.header__inline-menu > .list-menu > li > header-menu > details');
  const secondLevelDetails = document.querySelectorAll('.header__inline-menu details > ul > li > details');
  const menuSummaries = document.querySelectorAll('.header__inline-menu summary[data-menu-url]');

  const closeAllTopLevelMenus = () => {
    topLevelDetails.forEach((details) => {
      details.removeAttribute('open');
      const summary = details.querySelector(':scope > summary');
      if (summary) summary.setAttribute('aria-expanded', 'false');
    });
  };

  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    topLevelDetails.forEach((details) => {
      details.addEventListener('mouseenter', () => {
        closeAllTopLevelMenus();
        details.setAttribute('open', '');

        const summary = details.querySelector(':scope > summary');
        if (summary) summary.setAttribute('aria-expanded', 'true');
      });

      details.addEventListener('mouseleave', () => {
        details.removeAttribute('open');

        const summary = details.querySelector(':scope > summary');
        if (summary) summary.setAttribute('aria-expanded', 'false');
      });
    });

    secondLevelDetails.forEach((details) => {
      details.addEventListener('mouseenter', () => {
        const siblingDetails = details.parentElement?.parentElement?.querySelectorAll(':scope > li > details') || [];

        siblingDetails.forEach((sibling) => {
          if (sibling === details) return;
          sibling.removeAttribute('open');

          const siblingSummary = sibling.querySelector(':scope > summary');
          if (siblingSummary) siblingSummary.setAttribute('aria-expanded', 'false');
        });

        details.setAttribute('open', '');

        const summary = details.querySelector(':scope > summary');
        if (summary) summary.setAttribute('aria-expanded', 'true');
      });

      details.addEventListener('mouseleave', () => {
        details.removeAttribute('open');

        const summary = details.querySelector(':scope > summary');
        if (summary) summary.setAttribute('aria-expanded', 'false');
      });
    });
  }

  menuSummaries.forEach((summary) => {
    summary.addEventListener('click', (event) => {
      const menuUrl = summary.dataset.menuUrl;
      if (!menuUrl) return;

      // Keep keyboard toggle behavior for accessibility.
      if (event.detail === 0) return;

      // Clicking the caret should open/close the dropdown.
      if (event.target.closest('.icon-caret')) return;

      // Let modified clicks keep default browser behavior.
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      event.preventDefault();
      window.location.href = menuUrl;
    });
  });
});